import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import { withRouter } from '../../../common/withRouter';
import { ButtonOBSOLETED, Notification, Message } from "../../../web.common";
import { LayoutContext } from "../../layout/siteLayout";
import PageTop from "../../layout/PageTop";
import withApi from "../../higherOrderComponents/withApi";
import { DisplayDate } from "../../items";
import { apiErrorText, linkOrText, Pager } from "./shared";

const pageSize = 50;
const emptyFilters = { clubhouseSlug: "", userId: "" };

// People in the clubhouses: one row per membership, with the player's account link.
const Memberships = ({ api, searchParams }) => {
  const [filters, setFilters] = useState({ clubhouseSlug: searchParams?.get("clubhouseSlug") || "", userId: searchParams?.get("userId") || "" });
  const [rows, setRows] = useState(null);
  const [total, setTotal] = useState(0);
  const [skip, setSkip] = useState(0);
  const [notification, setNotification] = useState(null);

  const loadData = async (filtersToUse, nextSkip) => {
    try {
      const result = await api.clubhouseAdmin.getMemberships({
        clubhouseSlug: filtersToUse.clubhouseSlug.trim() || null,
        userId: filtersToUse.userId.trim() || null,
        take: pageSize,
        skip: nextSkip,
      });
      setRows(result.memberships);
      setTotal(result.total);
    } catch (e) {
      setNotification(new Message("error", apiErrorText(e, "Unable to load the memberships.")));
    }
  };

  useEffect(() => {
    loadData(filters, 0);
  }, []);

  const search = (e) => {
    e?.preventDefault();
    setSkip(0);
    loadData(filters, 0);
  };

  const changePage = (nextSkip) => {
    setSkip(nextSkip);
    loadData(filters, nextSkip);
  };

  const input = (name, placeholder) => (
    <input
      name={name}
      placeholder={placeholder}
      value={filters[name]}
      onChange={({ target }) => setFilters({ ...filters, [name]: target.value })}
    />
  );

  return (
    <LayoutContext.Consumer>
      {() => (
        <React.Fragment>
          <Notification newMessage={notification} />
          <div className="content-with-right-pane-delimiter">
            <PageTop documentTitle="Clubhouse memberships" documentDescription="Clubhouse memberships" />
            <h2 className="main-page-header">Clubhouse memberships</h2>

            <form onSubmit={search} style={{ display: "flex", gap: "1rem", alignItems: "flex-end", flexWrap: "wrap", margin: "1rem 0" }}>
              <label>
                Clubhouse (slug)<br />
                {input("clubhouseSlug", "koebenhavn")}
              </label>
              <label>
                User id<br />
                {input("userId", "guid")}
              </label>
              <ButtonOBSOLETED type="submit" buttonContent="Search" />
            </form>

            {rows == null ? (
              <span>Loading...</span>
            ) : (
              <article className="data-table-wrap">
                <table className="data-lists component-data-table cell-content-align-top">
                  <thead>
                    <tr>
                      <td>Clubhouse</td>
                      <td>Name</td>
                      <td>Email</td>
                      <td>Role</td>
                      <td>Joined</td>
                    </tr>
                  </thead>
                  <tbody>
                    {rows.map((membership) => (
                      <tr key={`${membership.clubhouseSlug}-${membership.userId}`}>
                        <td><Link to={`/clubhouse/${encodeURIComponent(membership.clubhouseSlug)}`}>{membership.clubhouseName || membership.clubhouseSlug}</Link></td>
                        <td>{linkOrText(`/user/${membership.userId}`, membership.userName)}</td>
                        <td>{membership.userEmail}</td>
                        <td>{membership.role}</td>
                        <td><DisplayDate>{membership.joinedAtUtc}</DisplayDate></td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </article>
            )}
            <Pager skip={skip} take={pageSize} total={rows ? total : null} onChange={changePage} />
          </div>
        </React.Fragment>
      )}
    </LayoutContext.Consumer>
  );
};

const MembershipsPage = withRouter(
  withApi(
    connect(
      ({ user }) => ({ isLoggedIn: !!user }),
      {}
    )(Memberships)
  )
);

MembershipsPage.requiresLogin = true;
MembershipsPage.propTypes = { isLoggedIn: PropTypes.bool };

export default MembershipsPage;
